import { ReactElement, ReactNode } from "react";

const Title = ({ children }: { children: ReactNode }) => {
  return (
    <div className="pt-5 font-josefin text-4xl collapse-title">{children}</div>
  );
};

const Content = ({ children }: { children: ReactNode }) => {
  return (
    <div className="font-nunito text-2xl collapse-content">{children}</div>
  );
};
const Collapse = ({
  children,
}: {
  children: ReactElement | ReactElement[];
}) => {
  return (
    <div
      tabIndex={0}
      className="bg-grape-light mb-3 px-4 border-base-300 rounded-badge collapse collapse-plus"
    >
      <input type="checkbox" />
      {children}
    </div>
  );
};
export default Object.assign(Collapse, {
  Title: Title,
  Content: Content,
});
